import { ApplicationResourceType } from '@flowx/designer/shared/entities/application.entity'

import { createDataModelEffects } from './data-model.effects'

import { DataModelApiService } from '../../api/data-model.api'
import { WorkflowDataModelActions } from '../actions/workflow.data-model.actions'

const workflowDataModelBasicEffects = createDataModelEffects(
  ApplicationResourceType.Workflow,
  {
    load: WorkflowDataModelActions.loadEntities,
    loadSuccess: WorkflowDataModelActions.loadEntitiesSuccess,
    loadFailure: WorkflowDataModelActions.loadEntitiesFailure,
    add: WorkflowDataModelActions.addEntity,
    addSuccess: WorkflowDataModelActions.addEntitySuccess,
    addFailure: WorkflowDataModelActions.addEntityFailure,
    edit: WorkflowDataModelActions.editEntity,
    editSuccess: WorkflowDataModelActions.editEntitySuccess,
    editFailure: WorkflowDataModelActions.editEntityFailure,
    addAttribute: WorkflowDataModelActions.addAttribute,
    addAttributeSuccess: WorkflowDataModelActions.addAttributeSuccess,
    addAttributeFailure: WorkflowDataModelActions.addAttributeFailure,
    editAttribute: WorkflowDataModelActions.editAttribute,
    editAttributeSuccess: WorkflowDataModelActions.editAttributeSuccess,
    editAttributeFailure: WorkflowDataModelActions.editAttributeFailure,
    requestDeleteEntity: WorkflowDataModelActions.deleteEntityRequested,
    deleteEntity: WorkflowDataModelActions.deleteEntity,
    deleteEntitySuccess: WorkflowDataModelActions.deleteEntitySuccess,
    deleteEntityFailure: WorkflowDataModelActions.deleteEntityFailure,
    requestDeleteAttribute: WorkflowDataModelActions.deleteAttributeRequested,
    deleteAttribute: WorkflowDataModelActions.deleteAttribute,
    deleteAttributeSuccess: WorkflowDataModelActions.deleteAttributeSuccess,
    deleteAttributeFailure: WorkflowDataModelActions.deleteAttributeFailure,
    resetErrors: WorkflowDataModelActions.resetErrors,
    resetErrorsSuccess: WorkflowDataModelActions.resetErrorsSuccess,
    updateAttributeValidators: WorkflowDataModelActions.updateAttributeValidators,
    updateAttributeValidatorsSuccess: WorkflowDataModelActions.updateAttributeValidatorsSuccess,
    updateAttributeValidatorsFailure: WorkflowDataModelActions.updateAttributeValidatorsFailure,
  },
  DataModelApiService
)

export const workflowLoadEntities$ = workflowDataModelBasicEffects.loadEntities$
export const workflowAddEntity$ = workflowDataModelBasicEffects.addEntity$
export const workflowEditEntity$ = workflowDataModelBasicEffects.editEntity$
export const workflowAddAttribute$ = workflowDataModelBasicEffects.addAttribute$
export const workflowEditAttribute$ = workflowDataModelBasicEffects.editAttribute$
export const workflowSetNewEntityAsAttribute$ =
  workflowDataModelBasicEffects.setNewEntityAsAttribute$
export const workflowStartDeleteEntity$ = workflowDataModelBasicEffects.startDeleteEntity$
export const workflowDeleteEntity$ = workflowDataModelBasicEffects.deleteEntity$
export const workflowStartDeleteAttribute$ = workflowDataModelBasicEffects.startDeleteAttribute$
export const workflowDeleteAttribute$ = workflowDataModelBasicEffects.deleteAttribute$
export const workflowResetErrors$ = workflowDataModelBasicEffects.resetErrors$
export const workflowUpdateAttributeValidators$ =
  workflowDataModelBasicEffects.updateAttributeValidators$
